import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Cabecalho from './components/Cabecalho';
import Rodape from './components/Rodape';
import BotoesFlutuantes from './components/BotoesFlutuantes';
import Seo from './components/Seo';
import Home from './paginas/Home';
import ServicoPagina from './paginas/ServicoPagina';
import BrasiliaPagina from './paginas/BrasiliaPagina';
import SobrePagina from './paginas/SobrePagina';
import ContatoPagina from './paginas/ContatoPagina';
import NaoEncontrada from './paginas/NaoEncontrada';
import { SLUG_BRASILIA } from './seo';

/** Ao trocar de página, volta ao topo — ou vai até a seção indicada no hash. */
function AoTrocarDeRota() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // O efeito roda depois do commit, então a seção de destino já está no DOM.
    // O deslocamento do header fixo vem do `scroll-padding-top` do <html>.
    if (hash) {
      const alvo = document.getElementById(hash.slice(1));
      if (alvo) {
        alvo.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <>
      <Seo />
      <AoTrocarDeRota />

      <a className="pular" href="#conteudo">
        Pular para o conteúdo
      </a>

      <Cabecalho />

      <main id="conteudo">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<SobrePagina />} />
          <Route path="/contato" element={<ContatoPagina />} />
          <Route path={`/${SLUG_BRASILIA}`} element={<BrasiliaPagina />} />
          {/* Rotas estáticas ganham do parâmetro: o React Router ordena por
              especificidade, então /sobre nunca cai aqui. */}
          <Route path="/:slug" element={<ServicoPagina />} />
          <Route path="*" element={<NaoEncontrada />} />
        </Routes>
      </main>

      <Rodape />
      <BotoesFlutuantes />
    </>
  );
}
